export default __webpack_public_path__ + "images/aureth_489e46.svg";